<app-navbar appHideBreadcrumb>
    <h2>Aplicatiile mele</h2>
</app-navbar>


<div class="container" *ngIf="applicationsLoaded">
    <div class="view-applications-container">
        <div class="view-application-inner">
            <div class="row">
                <div class="col-12 mb-5">
                    <div class="no-applications-found" *ngIf="applications.length == 0; else viewApplications">
                        <p>Momentan nu ai aplicat la nici un job.</p>
                    </div>
                    <ng-template #viewApplications>
                        <div class="tab">
                            <button [ngClass]="{'active': showAllApps}" class="tablinks" (click)="displayApps('all')">Toate aplicatiile ({{applications.length}})</button>
                            <button [ngClass]="{'active': showAllInterviews}" class="tablinks" (click)="displayApps('interviews')">Interviurile mele ({{interviews.length}})</button>
                        </div>
                        <div class="select-tab">
                            <div *ngIf="showAllApps" class="view-all-applications">
                                <div class="view-application-single" *ngFor="let app of applications">
                                    <div class="bg-white p-10">
                                        <div class="row align-items-center">
                                            <div class="col-md-1 col-12 text-center">
                                                <img src="{{app.applicationDetail.logo}}" class="img-fluid" alt="Job">

                                            </div>
                                            <div class="col-md-5 text-md-left col-12 text-center">
                                                <h5 class="custom-section-title">{{app.applicationDetail.jobName}}</h5>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-location-pin green-color mr-2"></i>
                                                        <span *ngFor="let city of app.applicationDetail.city" class="city-enum">{{city}}</span>
                                                        | {{app.applicationDetail.country}}
                                                    </li>
                                                </ul>
                                                <ul class="list-unstyled" *ngIf="app.companyName">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-building green-color mr-2"></i>{{app.companyName}}
                                                    </li>
                                                </ul>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color" *ngFor="let type of app.applicationDetail.workTypeJob">
                                                        <i class="icofont-worker green-color mr-2"></i>{{type | enumTransform}}
                                                    </li>
                                                </ul>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-calendar green-color mr-2"></i>{{app.applicationDetail.postingDate | date:"dd/MM/yyyy"}}
                                                    </li>
                                                </ul>

                                            </div>
                                            <div class="col-md-6 col-12">
                                                <ul class="list-unstyled m-0 text-md-right text-center">
                                                    <li class="d-inline-block mr-2 mb-md-0 mb-2"
                                                        *ngIf="app.statusApplication.responseStatus !== 'interviewPlanned'; else showInterviewDate">
                                                        <span class="app-status" *ngIf="app.statusApplication.responseStatus === 'noAnswerReceived' || app.statusApplication.responseStatus === null">În așteptare</span>
                                                        <span class="app-status-rejected" *ngIf="app.statusApplication.responseStatus === 'applicationRejected'">Aplicație respinsă</span>
                                                    </li>
                                                    <ng-template #showInterviewDate>
                                                        <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                            <span class="app-interview">Interviu: {{app.statusApplication.interviewDate  | date:"dd-MM-yyyy h:mm a"}}</span>
                                                        </li>
                                                    </ng-template>
                                                    <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                        <a routerLink="/aplicatie/{{app.id}}">
                                                            <button class="c-btn view-button">Detalii</button>
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="showAllInterviews" class="view-all-interviews">
                                <div class="no-applications-found" *ngIf="interviews.length == 0">
                                    <p>Momentan nu ai interviuri stabilitie.</p>
                                </div>
                                <div class="view-application-single" *ngFor="let app of interviews">
                                    <div class="bg-white p-10">
                                        <div class="row align-items-center">
                                            <div class="col-md-1 col-12 text-center">
                                                <img src="{{this.app.applicationDetail.logo}}" class="img-fluid" alt="Job" *ngIf="this.app.applicationDetail.logo !== 'string' &&  this.app.applicationDetail.logo !==  ''; else placeholderImage">
                                                <ng-template #placeholderImage>
                                                    <img  src="assets/img/placeholder.png" class="img-fluid" alt="Job">
                                                </ng-template>

                                            </div>
                                            <div class="col-md-5 text-md-left col-12 text-center">
                                                <h5 class="custom-section-title">{{app.applicationDetail.jobName}}</h5>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-location-pin green-color mr-2"></i>{{app.applicationDetail.jobLocation}}
                                                    </li>
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-money-bag green-color mr-2"></i> {{app.applicationDetail.jobSalary}}
                                                    </li>
                                                </ul>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-worker green-color mr-2"></i>{{app.applicationDetail.workTypeJob | enumTransform}}
                                                    </li>
                                                </ul>
                                                <ul class="list-unstyled">
                                                    <li class="d-inline-block mr-2 blue-color">
                                                        <i class="icofont-calendar green-color mr-2"></i>{{app.applicationDetail.postingDate | date:"dd/MM/yyyy"}}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6 col-12">
                                                <ul class="list-unstyled m-0 text-md-right text-center">
                                                    <li class="d-inline-block mr-2 mb-md-0 mb-2" *ngIf="app.statusApplication.responseStatus !== 'interviewPlanned'; else showInterviewDate">
                                                        <span class="app-status">In asteptare</span>
                                                    </li>
                                                    <ng-template #showInterviewDate>
                                                        <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                            <span class="app-interview">Interviu: {{app.statusApplication.interviewDate  | date:"dd-MM-yyyy h:mm a"}}</span>
                                                        </li>
                                                    </ng-template>
                                                    <li class="d-inline-block mr-2 mb-md-0 mb-2">
                                                        <a routerLink="/aplicatie/{{app.id}}">
                                                            <button class="c-btn view-button">Detalii</button>
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer>
</app-footer>
